import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";

import useRuleForm from "./useRuleForm";
import RuleForm from "./RuleForm";

export default RuleFormDialog;

function RuleFormDialog(props) {
  const { mode, onAddRule, onEditRule, rule, ruleIdx, onClose } = props;

  const { formState, updateFormState, errors, validate } = useRuleForm(rule);

  const isModeAdd = mode === "add";

  const handlePrimary = () => {
    if (!validate()) {
      return;
    }

    isModeAdd ? onAddRule(formState) : onEditRule(formState, ruleIdx);
    onClose();
  };

  return (
    <Dialog
      open={true}
      onClose={onClose}
    >
      <DialogTitle>{isModeAdd ? "Add Rule" : "Edit Rule"}</DialogTitle>
      <DialogBody>
        <RuleForm
          formState={formState}
          updateFormState={updateFormState}
          errors={errors}
        />
      </DialogBody>
      <DialogActions>
        <Button
          outline
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button onClick={handlePrimary}>{isModeAdd ? "Add" : "Save"}</Button>
      </DialogActions>
    </Dialog>
  );
}
